import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-add-edit-user',
    templateUrl: './add-edit-user.component.html',
    styleUrls: ['./add-edit-user.component.scss']
})
export class AddEditUserComponent implements OnInit {

    constructor() { }
    person: any = {};
    userSelected: boolean = false;
    user = {} as ILocationUser;
    ngOnInit() {

    }
    onUserSelect(event) {
        this.person = event.user;
       
        this.user.UserId = 0;
        this.user.DisplayName = this.person.DisplayName;
        this.user.FirstName = this.person.FirstName;
        this.user.LastName = this.person.LastName;
        this.user.EmailAddress = this.person.EmailAddress;
        this.user.Active = true;
        this.userSelected = true;

    }
}
